import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./FolderNavigationNav.scss";

function FolderNavigationNav({
  configuration,
  setCurrentFolder,
  rootFolder,
  currentFolder,
}) {
  const [folderStack, setFolderStack] = useState([]);

  const goHome = () => {
    setFolderStack([rootFolder]);
    setCurrentFolder(rootFolder);
  };

  // nivel del breadcrumb
  const goToChildFolder = (childFolder, idx) => {
    setCurrentFolder(childFolder);

    setFolderStack((prev) => {
      //cortar breadcrumbs
      const next = [...prev.slice(0, idx + 1), childFolder];
      return next;
    });
  };
  const goToFolder = (folder, idx) => {
    setCurrentFolder(folder);

    setFolderStack((prev) => {
      //cortar breadcrumbs
      const next = [...prev.slice(0, idx), folder];
      return next;
    });
  };

  useEffect(() => {
    setFolderStack([rootFolder]);
    setCurrentFolder(rootFolder);
  }, [rootFolder]);

  return (
    <>
      <Navbar
        expand="lg"
        className="bg-light p-2 border rounded folder-navigation-nav"
      >
        <Container fluid>
          <Navbar.Toggle aria-controls="navbar-folder" />
          <Navbar.Collapse id="navbar-folder">
            <Nav className="align-items-center">
              <span
                onClick={goHome}
                className="nav-link px-0 text-dark folder-link"
                style={{ cursor: "pointer" }}
                title="Inicio"
              >
                <i className="fa-solid fa-home" />
              </span>

              {folderStack.map((folder, idx) => {
                const hasChildren = (folder.children?.length ?? 0) > 0;
                const isLast = idx === folderStack.length - 1;
                if (folder.id !== currentFolder.id) {
                  return (
                    <span key={folder.id} className="d-flex align-items-center">
                      <Nav.Link
                        href="#"
                        onClick={() => goToFolder(folder, idx)}
                        role="button"
                      >
                        <span className="text-dark folder-link">
                          {folder.name}
                        </span>
                      </Nav.Link>
                      {!isLast && <span className="nav-link">/</span>}
                    </span>
                  );
                }
                return (
                  <span key={folder.id} className="d-flex align-items-center">
                    {hasChildren ? (
                      <NavDropdown
                        className="nav-link p-0"
                        id={`nav-dropdown-folder-${folder.id}`}
                        title={
                          <span className="text-dark folder-link">
                            {folder.name}
                          </span>
                        }
                      >
                        {folder.children.map((child) => (
                          <NavDropdown.Item
                            key={child.id}
                            onClick={() => goToChildFolder(child, idx)}
                          >
                            {child.name}
                          </NavDropdown.Item>
                        ))}
                      </NavDropdown>
                    ) : (
                      <span className="nav-link text-dark">{folder.name}</span>
                    )}

                    {!isLast && <span className="text-dark">/</span>}
                  </span>
                );
              })}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <>
        {currentFolder?.children.length > 0 && (
          <div className="rounded mt-2">
            <ul className="d-flex flex-column gap-2 list-unstyled">
              {currentFolder.children.map((child) => (
                <li key={child.id} className="w-100">
                  <button
                    className="w-100 p-3 d-flex align-items-center justify-content-start gap-2 border rounded shadow-sm folder-box-link"
                    onClick={() =>
                      goToChildFolder(child, folderStack.length - 1)
                    }
                  >
                    <i className="fa-regular fa-folder"></i>
                    <span>{child.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    </>
  );
}

export default FolderNavigationNav;
